import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ButtonGroupExt from '../../../../../legacy/components/ButtonGroupExt'
import CheckboxBlock from '../../../../../legacy/components/CheckboxBlock'
import { useHelpTextModal } from '../../../../../legacy/components/HelpTextModal'
import InputBlock from '../../../../../legacy/components/InputBlock'
import { debounce } from '../../../../../utils/debounce'
import validatorWrapper from '../../../../../utils/validatorWrapper'
import useStaticData from '../../../common/useStaticData'
import { crackInjectionCalculation } from '../../../store/calculationAction'
import { CrackWidthHelpBody, CrackWidthHelpHeader } from '../../../components'
import DropdownBlock from '../../../../../legacy/components/DropdownBlock'

const CrackInjection = () => {
  const dispatch = useDispatch()
  const input = useSelector((state) => state.calculation.input)
  const staticData = useSelector((state) => state.staticData)
  const {
    crackWidth,
    crackDepth,
    crackLength,
    overageFactor,
    injectionResin,
    pasteOverEpoxy,
    pasteOverBothSidesOfCrack,
    pumpingPortStyle,
    pumpingPortSpacing,
    validation,
  } = input
  // data
  const { getInjectionResinCrackWidthList, getCrackInjectionModels } = useStaticData(staticData)
  const { helpText, crackInjectionOptions } = staticData

  const injectionResinOptions = getInjectionResinCrackWidthList(crackWidth)

  // callback
  const handleInputChange = (name, myValue, status, validationMethods) => {
    const value = myValue.replace(/,/g, '')
    const errors = validatorWrapper.validate(validationMethods, value)

    const payload = [].concat({ [name]: value }).concat({ [name]: errors[0] })

    dispatch({ type: 'FIELD_INPUT_CALCULATION', payload: payload })
    let updatedInput = Object.assign({}, input, payload[0]) // payload[0] for state.input
    updatedInput.validation = Object.assign({}, updatedInput.validation, payload[1])

    delayedCalculation(updatedInput, staticData /*,  */)
  }

  const delayedCalculation = useCallback(
    debounce((updatedInput, staticData /*,  */) => {
      dispatch(crackInjectionCalculation(updatedInput, staticData /*  */))
    }, 500),
    [],
  )

  const onChangeCrackWidth = (name, value) => {
    const injectionResinOptions = getInjectionResinCrackWidthList(value)
    const injectionResinModel = searchModel(injectionResinOptions[0].value)

    const payload = {
      [name]: value,
      injectionResin: injectionResinOptions[0].value,
      injectionResinModel: injectionResinModel,
    }

    dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: payload })
    const updatedInput = Object.assign({}, input, payload)
    dispatch(crackInjectionCalculation(updatedInput, staticData)) //))
  }

  const searchModel = (target) =>
    staticData.crackInjectionApplicationModels.find(
      (item) => item.product === target && item.default === true,
    ).model

  const onChangeInjectionResin = (name, value) => {
    const injectionResinModel = searchModel(value)
    const payload = { [name]: value, injectionResinModel: injectionResinModel }

    dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: payload })
    const updatedInput = Object.assign({}, input, payload)
    dispatch(crackInjectionCalculation(updatedInput, staticData)) //))
  }

  const onChangePasteOverEpoxy = (name, value) => {
    let payload = { [name]: value }

    if (value === 'none') {
      payload = Object.assign({}, payload, {
        pasteOverEpoxyModel: undefined,
        pumpingPortModel: undefined,
        injectionFittingModel: undefined,
        pasteOverBothSidesOfCrack: undefined,
        pumpingPortStyle: undefined,
        pumpingPortSpacing: undefined,
      })
    } else {
      const pasteOverEpoxyModel = searchModel(value)
      payload = Object.assign({}, payload, {
        pasteOverEpoxyModel: pasteOverEpoxyModel,
        pasteOverBothSidesOfCrack:
          pasteOverBothSidesOfCrack === undefined ? false : pasteOverBothSidesOfCrack,
        pumpingPortModel: 'EIP-EZAKT',
        injectionFittingModel: 'EIF-EZ',
        pumpingPortStyle: 'Flush Mount',
        pumpingPortSpacing: '4',
      })
    }
    dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: payload })
    const updatedInput = Object.assign({}, input, payload)

    dispatch(crackInjectionCalculation(updatedInput, staticData))
  }

  const onChangePumpingPortStyle = (name, value) => {
    const pumpingPortModel = searchModel(value)
    const payload = { [name]: value, pumpingPortModel: pumpingPortModel }

    dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: payload })
    const updatedInput = Object.assign({}, input, payload)
    dispatch(crackInjectionCalculation(updatedInput, staticData)) //))
  }

  const onChangeExt = (name, value) => {
    const payload = { [name]: value }

    dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: payload })
    const updatedInput = Object.assign({}, input, payload)
    dispatch(crackInjectionCalculation(updatedInput, staticData)) //))
  }

  const [crackWidthModal, CrackWidthModal] = useHelpTextModal()

  const crackWidthProps = {
    dropdownProps: {
      selection: true,
      'data-testid': 'crackWidth'
    },
    name: 'crackWidth',
    value: crackWidth,
    options: crackInjectionOptions['crackWidth'],
    label: 'Average Crack Width',
    popoverText: '',
    helpTextModal: crackWidthModal,
    onChange: onChangeCrackWidth,
  }

  const overageFactorProps = {
    dropdownProps: {
      selection: true,
      'data-testid': 'overageFactor'
    },
    name: 'overageFactor',
    value: overageFactor,
    options: crackInjectionOptions['overageFactor'],
    label: 'Overage Factor',
    popoverText: helpText['overageFactor-CI'],
    onChange: onChangeExt,
  }

  const pasteOverBothSidesOfCrackProps = {
    name: 'pasteOverBothSidesOfCrack',
    value: pasteOverBothSidesOfCrack,
    label: 'Paste-Over Both Sides Of Crack',
    inputLabel: 'Yes, seal back of crack',
    popoverText: helpText['pasteOverBothSidesOfCrack'],
    onChange: onChangeExt,
    containerProps: {'data-testid': 'pasteOverBothSidesOfCrack'}
  }

  const pumpingPortSpacingProps = {
    dropdownProps: {
      selection: true,
      'data-testid': 'pumpingPortSpacing'
    },
    name: 'pumpingPortSpacing',
    value: pumpingPortSpacing,
    options: crackInjectionOptions['pumpingPortSpacing'],
    label: 'Pumping Port Spacing',
    onChange: onChangeExt,
  }

  return (
    <>
      <section id="aceCrackInputModal">
        <CrackWidthModal header={<CrackWidthHelpHeader />} body={<CrackWidthHelpBody />} />
      </section>

      <section id="aceCrackInputInstallation">
        <h3>Installation</h3>

        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
            <DropdownBlock {...crackWidthProps} />
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
            <InputBlock
              name={'crackDepth'}
              value={crackDepth}
              onChange={handleInputChange}
              status={validation.crackDepth}
              unit="in"
              label={'Crack Depth'}
              validationMethods={['isNotEmpty', 'isDecimal', 'validCrackDepth']}
              containerProps={{ 'data-testid': 'crackDepth' }}
            />
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
            <InputBlock
              name="crackLength"
              value={crackLength}
              onChange={handleInputChange}
              status={validation.crackLength}
              unit="ft"
              label={'Crack Length'}
              validationMethods={['isNotEmpty', 'isInt', 'validCrackLength']}
              containerProps={{ 'data-testid': 'crackLength' }}
            />
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
            <DropdownBlock {...overageFactorProps} />
          </div>
        </div>
      </section>

      <section id="aceCrackInputProductSelections">
        <h3>Product Selections</h3>

        <h4>Injection Resin</h4>

        <ButtonGroupExt
          name={'injectionResin'}
          value={injectionResin}
          options={injectionResinOptions}
          handleButtonClick={onChangeInjectionResin}
          colClass={'col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-2 -skinny'}
          containerProps={{ 'data-testid': 'injectionResin' }}
        />

        <section id="aceCrackInputPasteOver">
          <h4>Paste-Over Epoxy</h4>

          <ButtonGroupExt
            name={'pasteOverEpoxy'}
            value={pasteOverEpoxy}
            options={crackInjectionOptions['pasteOverEpoxy']}
            handleButtonClick={onChangePasteOverEpoxy}
            colClass={'col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3 -skinny'}
            containerProps={{ 'data-testid': 'pasteOverEpoxy' }}
          />
        </section>

        {pasteOverEpoxy !== 'none' ? (
          <>
            <div className="row">
              <div className="col" id="aceCrackInputBothSidesCrack">
                <CheckboxBlock {...pasteOverBothSidesOfCrackProps} />
              </div>
            </div>

            <h4>Pumping Port Style</h4>

            <ButtonGroupExt
              name={'pumpingPortStyle'}
              value={pumpingPortStyle}
              options={crackInjectionOptions['pumpingPortStyle']}
              handleButtonClick={onChangePumpingPortStyle}
              colClass={'col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3 -skinny'}
              containerProps={{ 'data-testid': 'pumpingPortStyle' }}
            />

            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                <DropdownBlock {...pumpingPortSpacingProps} />
              </div>
            </div>
          </>
        ) : null}
      </section>
    </>
  )
}

export default CrackInjection
